import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { TESTIMONIALS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/testimonials/")({
  component: () => <DeptContentList cfg={TESTIMONIALS} />,
});
